import { render, staticRenderFns } from "./TokenDetection.vue?vue&type=template&id=6fad03d0&scoped=true&"
import script from "./TokenDetection.vue?vue&type=script&lang=js&"
export * from "./TokenDetection.vue?vue&type=script&lang=js&"
import style0 from "./TokenDetection.vue?vue&type=style&index=0&id=6fad03d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad03d0",
  null
  
)

export default component.exports